import React from 'react';
import { Card } from 'react-bootstrap';
import * as LuIcon from 'react-icons/lu';

import { useTranslation } from '../../../translations';
import {
  StepErrorDto,
  StepErrorDtoLevelEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';

interface StageModalRequestsProps {
  items: StepErrorDto[];
}

export const StageModalRequests: React.FC<StageModalRequestsProps> = ({
  items,
}) => {
  const { t, tk } = useTranslation('projectLng');

  if (items.length === 0) {
    return null;
  }

  const getLevelPriority = (level: StepErrorDtoLevelEnum): number => {
    switch (level) {
      case StepErrorDtoLevelEnum.RequestError:
        return 1;
      case StepErrorDtoLevelEnum.RequestInfo:
        return 2;
      default:
        return 3;
    }
  };

  const sortedItems = [...items].sort(
    (a, b) => getLevelPriority(a.level) - getLevelPriority(b.level),
  );

  return (
    <Card className="stage-modal-card stage-modal-card-requests rounded-3">
      <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2 text-dark">
        {t(tk.timeLine.requestInfo)}
      </h6>
      <div className="d-flex flex-column gap-2">
        {sortedItems.map((item, index) => {
          const isError = item.level === StepErrorDtoLevelEnum.RequestError;
          const Icon = isError ? LuIcon.LuTriangleAlert : LuIcon.LuInfo;
          const colorClass = isError ? 'text-danger' : 'text-primary';

          return (
            <div
              key={index}
              className={`d-flex align-items-start ms-2 ${colorClass}`}
            >
              <Icon className="me-2 my-1" size={16} />
              <span
                className="text-dark pe-1"
                dangerouslySetInnerHTML={{ __html: item.message }}
              />
            </div>
          );
        })}
      </div>
    </Card>
  );
};
